<div class="col-md-6 offset-md-3 modal fade show align-middle">
  <div class="card shadow p-3 mb-5 bg-white rounded">
    <div class="card-header text-white bg-primary"><i class="fa fa-users" aria-hidden="true"></i> Identification</div>
    <div class="card-body">
      <span *ngIf="!loading">Une erreur est survenue lors de l'authentification. Veuillez réessayer ou contacter votre administrateur</span>
    </div>
  </div>
</div>
